import React from 'react';

const MusicStatus = ({ status, loading, onRefresh }) => {
  if (!status) {
    return (
      <div className="music-status">
        <div className="status-card">
          <h2>No Status Available</h2>
          <p>Unable to connect to the music streamer.</p>
        </div>
      </div>
    );
  }

  const formatDuration = (seconds) => {
    if (!seconds) return 'Unknown';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="music-status">
      <div className="status-header">
        <h2>Current Status</h2>
        <button 
          className="refresh-btn"
          onClick={onRefresh}
          disabled={loading}
        >
          {loading ? 'Refreshing...' : 'Refresh'}
        </button>
      </div>

      <div className="status-grid">
        <div className="status-card current-song">
          <h3>🎵 Now Playing</h3>
          {status.current_song ? (
            <div className="song-info">
              <div className="song-title">{status.current_song.title}</div>
              <div className="song-details">
                <span>Duration: {formatDuration(status.current_song.duration_seconds)}</span>
                <span>Plays: {status.current_song.play_count}</span>
                <span>Last Played: {formatDate(status.current_song.last_played)}</span>
              </div>
            </div>
          ) : (
            <div className="no-song">No song currently playing</div>
          )}
        </div>

        <div className="status-card next-song">
          <h3>⏭️ Next Up</h3>
          {status.next_song ? (
            <div className="song-info">
              <div className="song-title">{status.next_song.title}</div>
              <div className="song-details">
                <span>Duration: {formatDuration(status.next_song.duration_seconds)}</span>
                <span>Plays: {status.next_song.play_count}</span>
              </div>
            </div>
          ) : (
            <div className="no-song">No next song queued</div>
          )}
        </div>

        <div className="status-card playlist-info">
          <h3>📋 Playlist Info</h3>
          <div className="playlist-details">
            <div className="info-item">
              <span className="label">Position:</span>
              <span className="value">{status.playlist_position + 1}</span>
            </div>
            <div className="info-item">
              <span className="label">Total Songs:</span>
              <span className="value">{status.total_songs}</span>
            </div>
            <div className="info-item">
              <span className="label">Status:</span>
              <span className={`value ${status.is_streaming ? 'streaming' : 'stopped'}`}>
                {status.is_streaming ? '🟢 Streaming' : '🔴 Stopped'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicStatus;
